import { DashboardState } from "../interfaces/dashboard-state.interface";

export const initialState: DashboardState = {
  blockUserFeature: {
    payload: null,
    response: null,
    error: null,
    isLoading: false,
  },
  unblockUserFeature: {
    payload: null,
    response: null,
    error: null,
    isLoading: false,
  },
  deleteUserFeature: {
    selectedLogon: "",
    error: null,
    success: false
  },
};
